import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent
  implements AfterViewInit {

  @ViewChild(
    'canvas',
    { static: true }
  )
  canvasRef!: ElementRef<HTMLCanvasElement>;


  @Output()
  signatureGenerated =
    new EventEmitter<string>();


  private ctx!: CanvasRenderingContext2D;

  private drawing = false;

  private hasSignature = false;


  ngAfterViewInit(): void {

    const canvas =
      this.canvasRef.nativeElement;

    const rect =
      canvas.getBoundingClientRect();


    canvas.width =
      rect.width;

    canvas.height =
      rect.height;


    this.ctx =
      canvas.getContext('2d')!;


    this.ctx.lineWidth = 2;

    this.ctx.lineCap =
      'round';

    this.ctx.lineJoin =
      'round';

    this.ctx.strokeStyle =
      '#000';


    canvas.addEventListener(
      'mousedown',
      this.startDraw
    );

    canvas.addEventListener(
      'mousemove',
      this.draw
    );

    canvas.addEventListener(
      'mouseup',
      this.endDraw
    );

    canvas.addEventListener(
      'mouseleave',
      this.endDraw
    );


    canvas.addEventListener(
      'touchstart',
      this.startDraw,
      {
        passive: false
      }
    );

    canvas.addEventListener(
      'touchmove',
      this.draw,
      {
        passive: false
      }
    );

    canvas.addEventListener(
      'touchend',
      this.endDraw
    );

  }


  startDraw = (
    event: MouseEvent | TouchEvent
  ): void => {

    this.drawing = true;

    this.hasSignature = true;

    this.draw(event);

  };


  draw = (
    event: MouseEvent | TouchEvent
  ): void => {

    if (!this.drawing) {
      return;
    }


    const canvas =
      this.canvasRef.nativeElement;

    const rect =
      canvas.getBoundingClientRect();


    let x: number;

    let y: number;


    if (
      event instanceof TouchEvent
    ) {

      const touch =
        event.touches[0];

      if (!touch) {
        return;
      }


      x =
        touch.clientX -
        rect.left;

      y =
        touch.clientY -
        rect.top;

    }
    else {

      x =
        event.clientX -
        rect.left;

      y =
        event.clientY -
        rect.top;

    }


    this.ctx.lineTo(
      x,
      y
    );

    this.ctx.stroke();

    this.ctx.beginPath();

    this.ctx.moveTo(
      x,
      y
    );


    event.preventDefault();

  };


  endDraw = (
    _event: Event
  ): void => {

    this.drawing = false;

    this.ctx.beginPath();

  };


  clearCanvas(): void {

    const canvas =
      this.canvasRef.nativeElement;


    this.ctx.clearRect(
      0,
      0,
      canvas.width,
      canvas.height
    );


    this.hasSignature =
      false;

  }


  emitSignature(): void {

    if (!this.hasSignature) {
      return;
    }


    const canvas =
      this.canvasRef.nativeElement;


    const dataUrl =
      canvas.toDataURL(
        'image/png'
      );


    this.signatureGenerated.emit(
      dataUrl
    );

  }

}